import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { OrganisationalUnit } from '@teammood/shared/util/core';

@Injectable(
    { providedIn: 'root' }
  )
export class SetupService {
    constructor(private http: HttpClient){}

  
    async getOrganisationalUnits(teamId: string): Promise<OrganisationalUnit> {
        return await firstValueFrom(this.http.get<OrganisationalUnit>('/api/team/' + teamId + '/organisationalUnits'));
    }

    async getAvailableOrganisationalUnits(): Promise<OrganisationalUnitNamesByType[]> {
        return await firstValueFrom(this.http.get<OrganisationalUnitNamesByType[]>('/api/user/orgunits/available'));
    }

    async createOrganisationalUnit(orgUnit: OrganisationalUnit, teamId: string): Promise<OrganisationalUnit[]> {
        return await firstValueFrom(this.http.put<OrganisationalUnit[]>('/api/team/' + teamId + '/organisationalUnits/new', {...orgUnit}));
    }

    async deleteOrganisationalUnit(orgUnit: OrganisationalUnit, teamId: string): Promise<OrganisationalUnit[]> {
        return await firstValueFrom(this.http.delete<OrganisationalUnit[]>('/api/team/' + teamId + '/organisationalUnits/' + orgUnit.id));
    }

    async updateOrganisationalUnit(orgUnit: OrganisationalUnit, teamId: string): Promise<OrganisationalUnit[]> {
        return await firstValueFrom(this.http.post<OrganisationalUnit[]>('/api/team/' + teamId + '/organisationalUnits/' + orgUnit.id, {...orgUnit}));
    }

    findAllOrgUnitTypes(orgUnits: OrganisationalUnitNamesByType[]): string[] {
        return orgUnits.map(ou => ou.type);
    }

    findAllOrgUnitNames(orgUnits: OrganisationalUnitNamesByType[], type: string): string[] {
        return orgUnits.filter(ou => ou.type === type).flatMap(ou => ou.values);
    }
}

export interface OrganisationalUnitNamesByType {
    type: string,
    values: string[] // names of this org unit type
}